import { MenuItem } from 'primeng/api';

export const formGeneratorBreadcrumbsConfig: MenuItem[] = [
  {
    title: 'navigation.formGenerator.label',
    label: 'navigation.formGenerator.label',
    id: 'form-generator',
    routerLink: '/panel/form-generator',
  },
];
